import { useState, useEffect, useCallback } from "react";
import {
  getToken,
  getRangeDates,
  formatDateTime,
} from "../../../../utils/utils";
import axios from "axios";
import { ENDPOINT } from "../../../../constants/endpointConstants";
import PieChart from "../../../../components/PieChart/PieChart";

export const InsightLocalVsDelivery = ({ startDate, endDate }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getLocalVsDeliveryData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const token = getToken();
      const [dateInitFormatted, dateFinishFormatted] = getRangeDates(
        startDate,
        endDate
      );
      const requestBody = {
        startDate: formatDateTime(dateInitFormatted),
        endDate: formatDateTime(dateFinishFormatted),
      };
      const { data } = await axios.post(
        ENDPOINT.POST_LOCAL_VS_DELIVERY,
        requestBody,
        token
      );
      const chartData = {
        labels: ["Local", "Domicilio"],
        datasets: [
          {
            label: "Revenue",
            data: [data.local.count, data.delivery.count],
            backgroundColor: ["#ffbe73", "#4bc0c0"],
            borderColor: ["#ffbe73", "#4bc0c0"],
            borderWidth: 1,
          },
        ],
      };

      setData(chartData);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (startDate && endDate) {
      getLocalVsDeliveryData();
    }
  }, [startDate, endDate, getLocalVsDeliveryData]);

  return (
    <div>
      {loading && <div>Cargando...</div>}
      {error && <div>Error</div>}
      {data && <PieChart data={data} showDataLabels={true} />}
    </div>
  );
};
export default InsightLocalVsDelivery;
